module.exports = __webpack_public_path__ + "bdb5407e399ce5623a937c894862cc48.svg";